import Popover from 'bootstrap/js/dist/popover';
import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Scrollspy from 'bootstrap/js/dist/scrollspy';

window.onload = () => {
	//
	// js pour désactiver l'action des liens avec juste une ancre
	//
	document.querySelectorAll('a[href="#"]').forEach((el) => {
		el.addEventListener('click', (event) => {
			event.preventDefault();
		})
	});

	//
	// js pour la réécriture des emails
	//
	document.querySelectorAll('.obfsclk').forEach((el) => {
		el.innerHTML = el.innerHTML.replace(new RegExp('{AT}', 'g'), '@').replace(new RegExp('{DOT}', 'g'), '.');
		el.classList.remove('d-none');
	});

	//
	// js pour afficher/masquer le bouton pour retourner en haut de page
	//
	if(document.querySelector('.scrollto')) {
		var prevScrollpos = window.pageYOffset;

		window.onscroll = function() {
			if(window.outerHeight >= 356) {
				var currentScrollPos = window.pageYOffset;

				let scrollto = document.querySelector('.scrollto');

				if(scrollto) {
					if(prevScrollpos <= currentScrollPos || currentScrollPos <= 0) {
						scrollto.classList.remove('bottom-4');
					} else {
						scrollto.classList.add('bottom-4');
					}
				}

				prevScrollpos = currentScrollPos;
			}
		}
	}

	//
	// js pour placer le bouton pour retourner en haut de page
	//
	function displayRetour() {
		let scrollTo = document.querySelector('.scrollto');

		if(scrollTo) {
			let marginLeft = document.querySelector('body > div.mx-auto').offsetWidth - scrollTo.offsetWidth.toFixed(0);

			scrollTo.style.marginLeft = marginLeft + 'px';
			scrollTo.classList.remove('opacity-0');
		}
	}

	displayRetour();

	addEventListener('resize', () => {
		displayRetour();
	});

	//
	// js pour dupliquer le menu
	//
	function duplicate() {
		if(document.querySelector('#duplicate')) {
			if(window.innerWidth >= 984) {
				if(document.querySelector('#duplicated') === null) {
					let clone		= document.querySelector('#duplicate').cloneNode(true);
					let logo		= clone.querySelector('#logo');
					let menu		= clone.querySelector('#menu');
					let menuLabel	= menu.querySelector('#menuLabel');
					let button		= clone.querySelector('button[data-bs-target="#menu"]');

					clone.removeAttribute('id');

					logo.src		= logo.src.replace('-white', '');
					logo.removeAttribute('id');

					clone.querySelectorAll('a').forEach(function(link) {
						link.setAttribute('tabindex', '-1');
					});

					menu.setAttribute('id', menu.getAttribute('id') + '-duplicated');
					menu.setAttribute('aria-labelledby', menu.getAttribute('aria-labelledby') + '-duplicated');

					menuLabel.setAttribute('id', menuLabel.getAttribute('id') + '-duplicated');

					button.setAttribute('data-bs-target', button.getAttribute('data-bs-target') + '-duplicated');
					button.setAttribute('aria-controls', button.getAttribute('aria-controls') + '-duplicated');

					let div			= document.createElement('div');

					div.appendChild(clone);
					div.setAttribute('id', 'duplicated');
					div.classList.add('bg-opacity-75', 'bg-white', 'blur', 'd-none', 'd-lg-block', 'header', 'max-w-100', 'position-fixed', 'top-0', 'w-100', 'z-3');

					document.querySelector('#header').before(div);
				}
			} else if(document.querySelector('#duplicated')) {
				document.querySelector('#duplicated').remove();
			}
		}
	}

	duplicate();

	addEventListener('resize', () => {
		duplicate();
	});

	//
	// js pour ajouter la balise title aux liens qui s'ouvrent dans une nouvelle fenêtre
	//
	document.querySelectorAll('.wysiwyg a[target="_blank"]').forEach(function(link) {
		if(!link.hasAttribute('title')) {
			var regex = /^(www|http)/;

			if(regex.test(link.textContent)) {
				link.setAttribute('title', link.textContent + ' [nouvelle fenêtre]');
			} else {
				link.setAttribute('title', link.textContent.charAt(0).toUpperCase() + link.textContent.slice(1) + ' [nouvelle fenêtre]');
			}
		}
	});

	//
	// js pour afficher le gestionnaire de consentement aux cookies et pour modifier le positionnement du focus
	//
	document.querySelectorAll('.complianz > *, a.complianz').forEach((el) => {
		el.addEventListener('click', (event) => {
			event.preventDefault();

			cmplz_set_banner_status('');

			if(document.querySelector('.cmplz-categories-type-view-preferences').classList.contains('cmplz-categories-visible')) {
				document.querySelector('.cmplz-category.cmplz-functional > summary').focus();
			} else {
				document.querySelector('.cmplz-btn.cmplz-accept').focus();
			}
		});
	});

	document.querySelector('.cmplz-btn.cmplz-view-preferences').addEventListener('click', function() {
		setTimeout(function() {
			document.querySelector('.cmplz-category.cmplz-functional > summary').focus();
		}, 100);
	});

	//
	// js pour modifier l'affichage du formulaire présent le gestionnaire de consentement aux cookies
	//
	document.querySelectorAll('#cmplz-cookiebanner-container .cmplz-close svg.fa-times').forEach(function(svg) {
		svg.setAttribute('height', '20');
	});

	document.querySelectorAll('#cmplz-cookiebanner-container details:not(.cmplz-functional) .cmplz-banner-checkbox').forEach(function(banner) {
		banner.classList.add('d-flex', 'form-switch', 'lh-1');
	});

	document.querySelectorAll('#cmplz-cookiebanner-container details:not(.cmplz-functional) .cmplz-banner-checkbox .cmplz-consent-checkbox').forEach(function(checkbox) {
		checkbox.classList.add('cursor-pointer', 'form-check-input', 'ms-0', 'mt-0');
	});

	document.querySelectorAll('#cmplz-cookiebanner-container details:not(.cmplz-functional) .cmplz-banner-checkbox .cmplz-label span.screen-reader-text').forEach(function(span) {
		span.classList.remove('screen-reader-text');
		span.classList.add('visually-hidden');
	});

	document.querySelectorAll('#cmplz-cookiebanner-container details:not(.cmplz-functional) .cmplz-banner-checkbox .cmplz-label').forEach(function(label) {
		label.removeAttribute('tabindex');
	});

	document.querySelectorAll('#cmplz-cookiebanner-container details:not(.cmplz-functional) .cmplz-banner-checkbox').forEach(function(banner) {
		banner.classList.remove('cmplz-banner-checkbox');
	});

	//
	// js pour copier un lien
	//
	const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
	const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new Popover(popoverTriggerEl));

	document.querySelectorAll('.copy').forEach(function(link) {
		link.addEventListener('click', function() {
			navigator.clipboard.writeText(link.getAttribute('data-url'));
		});
	});

	//
	// js pour transformer les liens
	//
	var links = document.querySelectorAll('[role="link"]');

	function dataToHref(link) {
		if(link.hasAttribute('data-href')) {
			link.setAttribute('href', link.getAttribute('data-href'));
			link.removeAttribute('data-href');
		}
	}

	links.forEach(function(link) {
		link.addEventListener('mouseover', function() {
			dataToHref(this);
		});

		link.addEventListener('focusin', function() {
			dataToHref(this);
		});

		link.addEventListener('click', function() {
			dataToHref(this);
		});
	});

	//
	// js pour calculer la taille de la scrollbar
	//
	function getScrollbarWidth() {
		let body			= document.querySelector('body');

		let div				= document.createElement('div');

		div.style.overflowY	= 'scroll';
		div.style.width		= '20px';
		div.style.height	= '20px';

		document.body.append(div);

		let scrollWidth		= div.offsetWidth - div.clientWidth;

		div.remove();

		for(let i = body.classList.length - 1; i >= 0; i--) {
			const className	= body.classList[i];
			if(className.startsWith('scrollbar-')) {
				body.classList.remove(className);
			}
		}

		if(scrollWidth == 0 || scrollWidth == 12 || scrollWidth == 15 || scrollWidth == 17) {
			body.classList.add('scrollbar-' + scrollWidth);
		}
	}

	getScrollbarWidth();

	addEventListener('resize', () => {
		getScrollbarWidth();
	});

	//
	// js pour modifier la valeur cachée du champ "newsletter"
	//
	function changeHiddenValue(formName, inputCheckboxName) {
		const form						= document.getElementById(formName);

		if(form) {
			const input					= form.querySelector('input[name=' + formName + '-' + inputCheckboxName + ']');
			const inputHidden			= form.querySelector('input[name=' + formName + '-' + inputCheckboxName + '-hidden]');

			if(input && inputHidden) {
				if(input.checked) {
					inputHidden.value	= 'yes';
				} else {
					inputHidden.value	= 'no';
				}
			}
		}
	}

	changeHiddenValue('contact-form', 'newsletter');

	if(document.querySelector('#contact-form input[name=contact-form-newsletter]')) {
		document.querySelector('#contact-form input[name=contact-form-newsletter]').addEventListener('change', function() {
			changeHiddenValue('contact-form', 'newsletter');
		});
	}

	//
	// js pour les formulaires
	//
	function submitForm(formName) {
		const form						= document.getElementById(formName);

		if(form) {
			const submit				= form.querySelector('button[type=submit]');

			if(submit) {
				submit.addEventListener('click', function(event) {
					event.preventDefault();

					if(form.checkValidity()) {
						form.requestSubmit();
						form.classList.remove('was-validated');
					} else {
						form.classList.add('was-validated');
					}
				});
			}
		}
	}

	function sendForm(formName) {
		const form								= document.getElementById(formName);

		if(form) {
			form.addEventListener('submit', function(event) {
				event.preventDefault();

				const data						= new FormData(event.target);
				const email						= data.get(formName + '-email');
				const firstname					= data.get(formName + '-firstname');
				const lastname					= data.get(formName + '-lastname');
				const company					= data.get(formName + '-company');
				const siret						= data.get(formName + '-siret');
				const revenue					= data.get(formName + '-revenue');
				const numberofemployees			= data.get(formName + '-number_of_employees');
				const phone						= data.get(formName + '-phone');
				const message					= data.get(formName + '-message');

				const newsletter				= data.get(formName + '-newsletter-hidden');

				let _data = {
					action: 'form_' + formName,
					email: email
				};

				if(firstname) {
					_data.firstname				= firstname;
				}

				if(lastname) {
					_data.lastname				= lastname;
				}

				if(company) {
					_data.company				= company;
				}

				if(siret) {
					_data.siret					= siret;
				}

				if(revenue) {
					_data.revenue				= revenue;
				}

				if(numberofemployees) {
					_data.number_of_employees	= numberofemployees;
				}

				if(phone) {
					_data.phone					= phone;
				}

				if(message) {
					_data.message				= message;
				}

				if(newsletter) {
					_data.newsletter			= newsletter;
				}

				fetch('/wp-admin/admin-ajax.php', {
					method: 'POST',
					body: (new URLSearchParams(_data)).toString(),
					headers: { 'Content-type': 'application/x-www-form-urlencoded' }
				})
				.then(response => response.text())
				.then(response => {
					let alertMessage			= document.querySelector('.alert-success');

					if(alertMessage) {
						document.querySelector('.alert-success').remove();
					}

					form.insertAdjacentHTML('beforeBegin', response);

					form.reset();

					changeHiddenValue('contact-form', 'newsletter');

					sendinblue.identify(email);
				});
			});
		}
	}

	submitForm('contact-form');
	sendForm('contact-form');

	submitForm('newsletter-form');
	sendForm('newsletter-form');

	submitForm('telechargement-form');
	sendForm('telechargement-form');

	submitForm('test-form');
	sendForm('test-form');
}